export default __webpack_public_path__ + "static/media/DNo.38-7.d619ca3c.jpg";